import React, { Component, createRef } from "react"

/* Socket IO */
import { io } from "socket.io-client"

/* Widgets */
import { Preloader, Bet, DealerCards, PlayerCards, Busy, VipRates, VipMobileRate } from './widgets'

/* Components */
import { Timing, GamePayout, Jackpot, JackpotWin } from './components'

/* Constants */
import { images, env, sound, utils } from './constants'
import { LOADING, ERROR, CHOICE, GAME, WAITING, BUSY, INTERVAL } from './constants/status'

/* Cuba Go Poker UI */
import {
    Background, Balance, GameControl, GameInfo, Status, Error, Notification, Internet,
    Pass, Play, Buy, Swap, Insurance, FloatingMessages
} from '@cuba-go/poker-ui'

import History from "./widgets/History"

/* Rules */
import { list } from './constants/rules'

/* JWT */
import { decodeToken } from 'react-jwt'

/* REST API */
import { history } from "./api/History"
import { messages } from "./api/Support"

/* SWAL */
import Swal from "sweetalert2"

/* UUID */
import { v4 as uuidv4 } from 'uuid'

/* DEBOUNCE */
import { debounce } from 'lodash'

/* Internet speed check image URL */
const imgUrl = "https://cb.cuba-lv.com/images/dealerinfo/close.png"

/* Box indices */
const BOXES = [1, 2]

/* Сколько всплывающая операция висит на экране (мс) */
const OPERATION_TIME = 3500

const pathname = window.location.search
const token = pathname.length > 1 ? pathname.substring(1) : ""


class App extends Component {

    constructor() {
        super()

        const data = decodeToken(token)

        this.state = {

            /* General */
            cached: false,
            status: LOADING,
            isTableEmpty: false,
            userTime: null,

            /* Balance */
            balance: null,
            total: 0,
            currency: data?.currency || 'USD',
            identifier: data?.identifier || '1',
            lastWin: 0,

            /* Bet config */
            max: data?.max || 5000,
            min: data?.min || 50,
            maxPay: data?.maxPay || 100000,
            maxBonus: data?.maxBonus || 0,
            minBonus: data?.minBonus || 0,

            /* BONUS | джекпотная ставка доступна только если у оператора включён пул живых игр */
            withJackpot: data?.withJackpot === "yes",
            jackpot: null,

            /* BONUS | выигрыш пула — { total } для полноэкранной анимации, null пока джекпота не было */
            jackpotWin: null,

            /* Operator / appearance */
            operator: data?.operator || null,
            chips: Array.isArray(data?.chips) ? data.chips : [],
            backColor: data?.backColor || "",
            gameImg: data?.gameImg ? `${env.mediapoint}/images/table-images/` + data.gameImg : null,

            /* Bet selection */
            activeChip: 4,
            activeBoxes: 0,
            activeButtons: [0, 0],
            ante: [0, 0],
            bonus: [0, 0],
            last: [0, 0],
            lastBonus: [0, 0],

            /* Game state */
            dealt: false,
            actions: [0, 0],
            game: [0, 0],
            isBet: [0, 0],
            freezedBoxes: [],
            isOpen: [0, 0],
            result: [0, 0],
            bonusResult: [0, 0],
            gameInfo: null,
            transactions: [],
            operations: [],

            /* Cards */
            dealer: [],
            dealerGame: null,
            player: [[], []],
            playerGame: [],

            /* Dealer */
            dealerInfo: null,

            /* Card exchange */
            used: [0, 0],
            exchangeCards: [],

            /* Sixth card */
            sixthGame: [],

            /* Purchase */
            isPurchase: [0, 0],
            boxesToPurchase: 0,
            purchaseResult: [0, 0],
            removedCard: null,
            betIsTouched: [0, 0],

            /* Insurance */
            showInsurance: [0, 0],
            insurance: [0, 0],
            insuranceStatus: [0, 0],

            shadow: true,

            /* History */
            histories: [],
            historyLoading: true,
            historyPage: 1,
            historyHasMore: true,

            /* Session flags */
            closed: false,
            newDevice: false,
            isDisconnected: false,
            isPaused: false,
        }

        this.notify = React.createRef()

        this.socket = io(env.endpoint, { auth: { token: `${token}`, type: "player" } })

        this._timing = null

        /* Очередь всплывающих операций: на экране всегда только одна,
           иначе вторая уезжает под плашку джекпота */
        this._operationQueue = []
        this._operationTiming = null

        this._balanceErrorTiming = null
        this._maxBetErrorTiming = null
        this._background = createRef(null)

        /* JACKPOT | выигранный пул ждёт здесь конца раунда — см. queueJackpotWin */
        this._pendingJackpot = null
        this._jackpotTiming = null
    }


    // ─────────────────────────────────────────────────────────────
    // Lifecycle
    // ─────────────────────────────────────────────────────────────

    componentDidMount = () => {
        this.registerSocketEvents()
        this.cacheImages()
        this.loadHistory(1)
        this.loadSupportMessages()
    }

    componentWillUnmount = () => {
        this.socket.disconnect()
        this.clearOperations()
        this.clear()
    }


    // ─────────────────────────────────────────────────────────────
    // Shared empty game state
    // Used by clear / forceEndClear / reconnectionClear and socket resets.
    // ─────────────────────────────────────────────────────────────

    get emptyGameState() {
        return {
            activeBoxes: 0,
            activeButtons: [0, 0],
            total: 0,
            ante: [0, 0],
            bonus: [0, 0],
            actions: [0, 0],
            dealt: false,
            game: [0, 0],
            isBet: [0, 0],
            isOpen: [0, 0],
            result: [0, 0],
            bonusResult: [0, 0],
            betIsTouched: [0, 0],
            dealer: [],
            dealerGame: null,
            player: [[], []],
            playerGame: [],
            used: [0, 0],
            exchangeCards: [],
            sixthGame: [],
            isPurchase: [0, 0],
            boxesToPurchase: 0,
            purchaseResult: [0, 0],
            removedCard: null,
            showInsurance: [0, 0],
            insurance: [0, 0],
            insuranceStatus: [0, 0],
            freezedBoxes: [],
            isPaused: false,
        }
    }

    clear = (status) => {
        this.clearOperations()
        this.setState({
            ...this.emptyGameState,
            status: status || LOADING,
            gameInfo: null,
            transactions: [],
            dealerInfo: null,
            isTableEmpty: false,
        })
    }

    forceEndClear = () => {
        this.setState({
            ...this.emptyGameState,
            status: CHOICE,
            gameInfo: null,
            transactions: [],
        })
    }

    reconnectionClear = () => {
        this.setState({
            ...this.emptyGameState,
            status: INTERVAL,
            dealerInfo: null,
        })
    }


    // ─────────────────────────────────────────────────────────────
    // History & support
    // ─────────────────────────────────────────────────────────────

    loadHistory = (page = 1) => {
        const { histories } = this.state

        this.setState({ historyPage: page })

        history(token, page).then(response => {
            if (response.status === 200) {
                const list = page > 1 ? [...histories, ...response.data] : response.data
                const historyHasMore = response.data.length >= 10
                this.setState({ histories: list, historyLoading: false, historyHasMore })
            }
        }).catch(() => {
            this.setState({ histories: [], historyLoading: false })
        })
    }

    loadSupportMessages = () => {
        messages(token).then(response => {
            if (response.status === 200) {
                const t = setTimeout(() => {
                    if (this._background?.current) {
                        this._background.current.setSupportMessage(response.data)
                    }
                    clearTimeout(t)
                }, 2100)
            }
        })
    }

    sendMessage = (message) => {
        this.socket.emit("message", message.message)
        if (this._floatingMessages) {
            this._floatingMessages.sendMessage(message)
        }
    }

    sendSupportMessage = (message) => {
        this.socket.emit("supportMessage", message.message)
    }


    // ─────────────────────────────────────────────────────────────
    // Socket event registration
    // ─────────────────────────────────────────────────────────────

    registerSocketEvents = () => {
        const s = this.socket

        s.on("connect_error", () => this.onConnectError())
        s.on("disconnect", () => this.onDisconnect())
        s.on("connect", () => { })
        s.on("newDeviceConnection", () => this.onNewDeviceConnection())
        s.on("isBusy", () => this.onIsBusy())
        s.on("emptyTable", () => this.onEmptyTable())
        s.on("dealerInfo", data => this.onDealerInfo(data))
        s.on("dealerConnect", data => this.onDealerConnect(data))
        s.on("reconnection", data => this.onReconnection(data))
        s.on("dealt", () => this.onDealt())
        s.on("balance", data => this.setState({ balance: data }))
        s.on("dealer", data => this.onDealerCard(data))
        s.on("dealerCards", data => this.setState({ dealer: data }))
        s.on("purchaseCard", data => this.onPurchaseCard(data))
        s.on("dealerGame", data => this.setState({ dealerGame: data }))
        s.on("player", data => this.onPlayerCard(data))
        s.on("playerCards", cards => this.onPlayerCards(cards))
        s.on("playerGame", data => this.onPlayerGame(data))
        s.on("exchangePlayerGame", data => this.onExchangePlayerGame(data))
        s.on("exchangeCards", data => this.onExchangeCards(data))
        s.on("sixth", data => this.onSixth(data))
        s.on("sixthGame", data => this.onSixthGame(data))
        s.on("insuranceStatus", data => this.onInsuranceStatus(data))
        s.on("bonusResult", data => this.onBonusResult(data))
        s.on("jackpot", data => this.setState({ jackpot: data }))
        s.on("purchase", data => this.onPurchase(data))
        s.on("removedCard", data => this.onRemovedCard(data))
        s.on("status", data => this.onStatus(data))
        s.on("closeTable", () => this.onCloseTable())
        s.on("tableCloseNext", () => this.onTableCloseNext())
        s.on("tableBooked", () => this.onTableBooked())
        s.on("tableBookedNext", () => this.onTableBookedNext())
        s.on("closeWaiting", () => this.onCloseWaiting())
        s.on("result_all", data => this.onResultAll(data))
        s.on("gameInfo", data => this.setState({ gameInfo: data }))
        s.on("transaction", data => this.onTransaction(data))
        s.on("editTransaction", data => this.onEditTransaction(data))
        s.on("pause", () => this.onPause())
        s.on("continue", () => this.onContinue())
        s.on("forceEnd", () => this.onForceEnd())
        s.on("transactionError", () => this.onTransactionError())
        s.on("inactionReset", data => this.onInactionReset(data))
        s.on("playerNotification", data => this.notifyToggle('refund', 'refund', data))
        s.on("inactionDisconnect", () => this.onInactionDisconnect())
        s.on("inactionHold", () => this.onInactionHold())
        s.on("message", data => this.onMessage(data))
        s.on("adminSupportAnswer", data => this.onAdminSupportAnswer(data))
    }


    // ─────────────────────────────────────────────────────────────
    // Socket event handlers
    // ─────────────────────────────────────────────────────────────

    onConnectError = () => {
        this.clear()
        const t = setTimeout(() => {
            this.setState({ status: ERROR })
            clearTimeout(t)
        }, 1000)
    }

    onDisconnect = () => {
        this.setState({ isDisconnected: true })
        this.clear()
    }

    onNewDeviceConnection = () => {
        this.setState({ newDevice: true })
        this.socket.disconnect()
        this.clear()
    }

    onIsBusy = () => {
        const t = setTimeout(() => {
            this.setState({ status: BUSY, isTableEmpty: false })
            this.notifyToggle("busy", 'show')
            clearTimeout(t)
        }, 2050)
    }

    onEmptyTable = () => {
        this.setState({ isTableEmpty: true })
        this.notifyToggle("busy", 'close')
    }

    onDealerInfo = (data) => {
        const { dealerInfo } = this.state
        const delay = data?.afterConnect ? 200 : 2000

        setTimeout(() => {
            const t = setTimeout(() => {
                if (data) {
                    if (!dealerInfo && !data.disableStatusUpdate) {
                        this.setState({ status: CHOICE, isTableEmpty: false })
                    }
                } else {
                    this.clear(WAITING)
                }
                this.setState({ dealerInfo: data })
                clearTimeout(t)
            }, delay)

            setTimeout(() => this.setDealerStatus(data), data ? delay : 500)
        }, 500)
    }

    onDealerConnect = (data) => {
        const { dealerInfo } = this.state

        if (dealerInfo) {
            this.setState({ dealerInfo: data.storage })
        } else {
            const t = setTimeout(() => {
                this.setState({ dealerInfo: data.storage, status: data ? CHOICE : WAITING })
                clearTimeout(t)
            }, 2020)
        }

        this.setDealerStatus(data.storage)
    }

    onReconnection = (data) => {
        if (!data) return

        if (data.reason === "transaction") {
            this.notifyToggle("transaction", 'show')
        }

        this.reconnectionClear()

        const t = setTimeout(() => {
            const game = ['start', 'start']
            const actions = [0, 0]
            let used = [0, 0]
            let insurance = [0, 0]
            let insuranceStatus = [0, 0]
            let isPurchase = [0, 0]
            let swapCards = []
            let removedCard = null
            let dealerGame = null
            let playerCards = data.player
            // Merge snapshot with any real-time playerGame events that arrived
            // during the 2050ms delay (race: card scanned after reconnect but
            // before this timeout fires overwrites snapshot if not merged).
            const _snap = data.playerGame || []
            const _live = this.state.playerGame || []
            let playerGame = Array.from(
                { length: Math.max(_snap.length, _live.length, 2) },
                (_, i) => _snap[i] ?? _live[i] ?? null
            )

            /* Sixth card active */
            if (data.isSixth) {
                data.isSixth.forEach((item, i) => {
                    if (item) {
                        game[i] = 'start'
                        playerGame[i] = data.sixthGame[i]
                        used[i] = true
                        actions[i] = "sixth"
                    }
                })
            }

            /* Exchange active */
            if (Array.isArray(data.exchange) && data.exchange.length > 0) {
                data.exchange.forEach((item, i) => {
                    if (item) {
                        game[i] = 'exchange'
                        playerGame[i] = null
                        used[i] = true
                        actions[i] = "exchange"
                    }
                })
            }

            /* Sixth card visuals */
            if (data.sixthCard) {
                data.sixthCard.forEach((item, i) => {
                    if (item) {
                        playerCards[i].unshift({ ...item, isSixth: true })
                        used[i] = true
                        actions[i] = 0
                    }
                })
            }

            /* Exchange card visuals */
            if (Array.isArray(data.exchangeCards) && data.exchangeCards.length > 0) {
                data.exchangeCards.forEach((array, i) => {
                    if (Array.isArray(array) && array.length > 0) {
                        /* Only prepend isExchange cards when exchange is still active.
                         * If exchange[i] is empty, those cards are already in playerCards — adding them again causes 8-card display. */
                        const isActiveExchange = Array.isArray(data.exchange) && Array.isArray(data.exchange[i]) && data.exchange[i].length > 0
                        if (isActiveExchange) {
                            array.forEach(card => {
                                playerCards[i].unshift({ ...card, isExchange: true })
                            })
                        }
                        used[i] = true
                    }
                })
            }

            if (Array.isArray(data.swapCards) && data.swapCards.length > 0) {
                swapCards = data.swapCards.map((boxCards, i) => {
                    /* Only keep swapCards for boxes with active (incomplete) exchange.
                     * If exchange[i] is empty/missing, that box's exchange is done — clear it
                     * so the swap button hides and old cards don't reappear for the next box. */
                    if (Array.isArray(data.exchange) && Array.isArray(data.exchange[i]) && data.exchange[i].length > 0) {
                        return boxCards
                    }
                    return []
                })
            }
            if (Array.isArray(data.insuranceValue) && data.insuranceValue.length > 0) insurance = data.insuranceValue
            if (Array.isArray(data.insuranceStatus) && data.insuranceStatus.length > 0) insuranceStatus = data.insuranceStatus
            if (data.purchaseBox) isPurchase = data.purchaseBox
            if (data.removedCard) removedCard = data.removedCard
            if (data.dealerGame) dealerGame = data.dealerGame

            if (Array.isArray(data.pass) && data.pass.length > 0) {
                data.pass.forEach((item, i) => {
                    if (item) { game[i] = 'pass'; actions[i] = "pass" }
                })
            }

            if (Array.isArray(data.bet) && data.bet.length > 0) {
                data.bet.forEach((item, i) => {
                    if (item) { game[i] = 'bet'; actions[i] = "bet" }
                })
            }

            /* Restore isBet from freezedBoxes — built as a local array to avoid
             * React 18 batching stale-read: forEach + setAction would overwrite
             * box 0's isBet with the second box's stale [0,0] read. */
            const isBet = [0, 0]
            if (data.freezedBoxes?.length > 0) {
                data.freezedBoxes.forEach((item, i) => {
                    if (item === 'bet') {
                        isBet[i] = 'bet'
                        actions[i] = 'bet'
                    } else if (item) {
                        isBet[i] = 'no_bet'
                    }
                })
            }

            this.setState({
                activeBoxes: data.boxes,
                ante: data.ante,
                bonus: data.bonus || [0, 0],
                bonusResult: data.bonusResult || [0, 0],
                actions,
                player: playerCards,
                playerGame,
                dealer: data.dealer,
                dealerGame,
                gameInfo: data.gameID,
                transactions: data.transactions,
                dealt: data.dealt,
                shadow: data.shadow,
                game,
                used,
                exchangeCards: swapCards,
                total: data.total,
                last: data.ante,
                lastBonus: data.bonus || [0, 0],
                insurance,
                insuranceStatus,
                isPurchase,
                boxesToPurchase: data.boxesToPurchase,
                removedCard,
                freezedBoxes: data.freezedBoxes,
                isPaused: data.isPaused,
                isBet,
                status: data.status || GAME,
                userTime: data.held ? null : this.state.userTime,
            }, () => {
                /* Стол на удержании или идёт раздача — сразу прячем таймер решения (без «моргания» при перезагрузке) */
                if (data.held || data.dealing) {
                    this._timing?.hide()
                }
            })

            if (data.isPaused) this.notifyToggle("pause", "show")

            if (data.from === "continue") {
                setTimeout(() => this.notifyToggle('pause', 'close'), 2000)
            }

            this.notifyToggle('transaction', 'close')

            if (data.sixthGame) {
                this.setState({ sixthGame: data.sixthGame })
            }

            /* Restore result if game already finished */
            if (Array.isArray(data.result) && this.countTruthy(data.result) > 0) {
                const isBet = [0, 0]
                let total = data.total
                if (data.boxes === this.countTruthy(data.result)) total = 0

                data.result.forEach((item, i) => {
                    if (item && item.result !== 'lose' && data.bet?.[i]) {
                        isBet[i] = 'bet'
                    }
                })

                this.setState({ result: data.result, shadow: true, ante: data.ante, isBet, total, used: [true, true] })
            }

            clearTimeout(t)
        }, 2050)
    }

    /* BONUS result for a box — приходит сразу после 5-й карты бокса */
    onBonusResult = (data) => {
        if (!data || data.box === undefined || data.box === null || !data.result) return

        /* Результат этого бокса уже показан — повтор события игнорируем целиком */
        if (this.state.bonusResult[data.box]) return

        this.setState(prev => {
            const bonusResult = [...prev.bonusResult]

            if (bonusResult[data.box]) return null

            bonusResult[data.box] = data.result
            return { bonusResult }
        })

        /* JACKPOT | рояль флеш на бонусе забирает весь пул. Салюты ставим в очередь, а не показываем сразу:
           бонус считается по 5-й карте бокса, а карты дилера ещё не розданы — ждём события dealt.
           isJackpotDemo — тот же экран у аккаунта вне пула, но с пояснением про реальные деньги */
        if (data.result.isJackpot || data.result.isJackpotDemo) {
            this.queueJackpotWin(data.result.total, data.result.usd, data.result.isJackpotDemo === true)
        }

        if (data.result.result === "win") {
            sound.play('winsmall', 0.5)
        }
    }


    /* JACKPOT | выигрыш пула ждёт, пока дилер доложит свои карты: салюты выходят на полной раздаче */
    queueJackpotWin = (total, usd = null, demo = false) => {

        this._pendingJackpot = { total, usd, demo }

        /* Страховка: раздача могла оборваться и dealt не прийти — тогда показываем по таймеру */
        clearTimeout(this._jackpotTiming)
        this._jackpotTiming = setTimeout(() => this.showJackpotWin(), 15000)
    }

    showJackpotWin = () => {

        if (!this._pendingJackpot) return

        const win = this._pendingJackpot

        this._pendingJackpot = null
        clearTimeout(this._jackpotTiming)

        this.setState({ jackpotWin: win })
        sound.play('win', 1)
    }

    onDealt = () => {
        this.setState({ dealt: true, actions: [0, 0], game: ['start', 'start'], shadow: true })
        this.socket.emit("shadow", "yes")

        /* JACKPOT | все карты на столе — отдаём экран салютам */
        this.showJackpotWin()
    }

    onDealerCard = (data) => {
        this.setState(prev => {
            if (prev.dealer.some(e => e.uid === data.uid)) return null
            return { dealer: [data, ...prev.dealer] }
        })
    }

    onPurchaseCard = (data) => {
        const { dealer } = this.state
        const isDuplicate = dealer.some(e => e.uid === data.uid)
        if (!isDuplicate) {
            this.setState({ dealer: [data, ...dealer], actions: [0, 0], shadow: true })
            this.socket.emit("shadow", "yes")
        }
    }

    onPlayerCard = (data) => {
        if (data.card_index === 1 && data.check) {
            this.setState({ dealer: [], dealerGame: null, playerGame: [] })
        }

        this.setState(prev => {
            const cards = (data.card_index === 1 || data.card_index === 2)
                ? []
                : prev.player[data.index] || []

            if (cards.some(e => e.id === data.card.id)) return null

            const updatedPlayer = [...prev.player]
            updatedPlayer[data.index] = [data.card, ...cards]
            return { player: updatedPlayer }
        })
    }

    onPlayerCards = (cards) => {
        if (!this.arePlayerCardsEqual(this.state.player, cards)) {
            this.setState({ player: cards })
        }
    }

    onPlayerGame = (data) => {
        this.setState(prev => {
            const playerGame = [...prev.playerGame]
            playerGame[data.index] = data.playerGame
            return { playerGame }
        })
    }

    onExchangePlayerGame = (data) => {
        const { player_game, index } = data

        this.setState(prev => {
            const updatedPlayerGame = [...prev.playerGame]
            const updatedGame = [...prev.game]
            const updatedActions = [...prev.actions]

            updatedPlayerGame[index] = player_game
            updatedGame[index] = 'start'
            updatedActions[index] = 0

            return { playerGame: updatedPlayerGame, actions: updatedActions, shadow: true, game: updatedGame }
        })
        this.socket.emit("shadow", "yes")
    }

    onExchangeCards = (data) => {
        const { card, index } = data
        this.setState(prev => {
            const cards = prev.player[index] || []
            const isDuplicate = cards.some(e => e.id === card.id)
            if (isDuplicate) return null

            const updatedPlayer = [...prev.player]
            updatedPlayer[index] = [{ ...card, isExchange: true }, ...cards]

            const updatedGame = [...prev.game]
            updatedGame[index] = 'start'

            const updatedActions = [...prev.actions]
            updatedActions[index] = 0

            return { player: updatedPlayer, actions: updatedActions, game: updatedGame }
        })
    }

    onSixth = (data) => {
        const { card, index } = data
        let shouldEmitShadow = false
        this.setState(prev => {
            const cards = prev.player[index] || []
            const isDuplicate = cards.some(e => e.id === card.id)
            if (isDuplicate) return null

            const updatedPlayer = [...prev.player]
            updatedPlayer[index] = [{ ...card, isSixth: true }, ...cards]

            const updatedGame = [...prev.game]
            updatedGame[index] = 'start'

            const updatedActions = [...prev.actions]
            updatedActions[index] = 0

            shouldEmitShadow = true
            return { player: updatedPlayer, actions: updatedActions, shadow: true, game: updatedGame }
        })
        if (shouldEmitShadow) this.socket.emit("shadow", "yes")
    }

    onSixthGame = (data) => {
        const { playerGame, index } = data
        this.setState(prev => {
            const sixthGame = [...prev.sixthGame]
            sixthGame[index] = playerGame

            const updatedGame = [...prev.game]
            const validStates = ['start', 'bet', 'pass']
            if (!validStates.includes(updatedGame[index])) {
                updatedGame[index] = 'start'
            }

            return { sixthGame, game: updatedGame }
        })
    }

    onInsuranceStatus = (data) => {
        this.setState({ insuranceStatus: data })

        if (data[0] === "win" || data[1] === "win") {
            sound.play('winsmall')
            const t = setTimeout(() => { sound.play('repeat'); clearTimeout(t) }, 1000)
        } else {
            sound.play('selectchip')
        }
    }

    onPurchase = (data) => {
        const { status } = data
        if (this.countTruthy(status)) {
            this.setState({
                isPurchase: status,
                shadow: true,
                freezedBoxes: ['bet', 'bet'],
                boxesToPurchase: this.countTruthy(status)
            })
            this.socket.emit("shadow", "yes")
        }
    }

    onRemovedCard = (data) => {
        if (!this.state.removedCard) {
            this.setState({ removedCard: data })
        }
    }

    onStatus = (data) => {
        this.setState({ status: data })

        if (data === CHOICE) {
            this.loadHistory(1)
            this.setState({ ...this.emptyGameState, gameInfo: null, transactions: [], shadow: true })
        }
    }

    onCloseTable = () => {
        setTimeout(() => this.notifyToggle("tableClosed", "close"), 500)
        setTimeout(() => this.notifyToggle('waiting', 'show'), 1000)

        this.loadHistory(1)
        this.setState({ ...this.emptyGameState, status: WAITING, gameInfo: null, transactions: [], shadow: true })
    }

    onTableCloseNext = () => {
        this.notifyToggle("tableClosed", "show")
    }

    /* VIP бронь: стол занят бронью — следующего раунда не будет.
       «Стол занят» показываем последним: на подключении к уже забронированному столу
       перед этим успевает подняться «Дождитесь следующей игры» от пустого дилера */
    onTableBooked = () => {
        setTimeout(() => this.notifyToggle("tableClosed", "close"), 500)
        setTimeout(() => {
            this.notifyToggle("waiting", "close")
            this.notifyToggle("busy", "show")
        }, 2500)

        this.loadHistory(1)
        this.setState({ ...this.emptyGameState, status: WAITING, gameInfo: null, transactions: [], shadow: true })
    }

    /* VIP бронь: бронь начинается в течение часа — этот раунд последний */
    onTableBookedNext = () => {
        this.notifyToggle("tableClosed", "show")
    }

    onCloseWaiting = () => {
        this.notifyToggle("waiting", "close")
    }

    onResultAll = (data) => {
        if (!data) return

        const { result } = data
        if (!this.countTruthy(result)) return

        const { activeBoxes, isBet } = this.state
        const updatedIsBet = [...isBet]
        let winTotal = 0
        let maxPayCheck = false

        this.setState({ result, shadow: true, used: [true, true] })
        this.socket.emit("shadow", "yes")

        if (this.countTruthy(result) === activeBoxes) {
            this.setState({ total: 0 })

            result.forEach((item, i) => {
                if (item?.result === 'lose') updatedIsBet[i] = 0
                if (item?.maxPayCheck) maxPayCheck = true
                winTotal += item?.sum || 0
            })

            this.setState({ isBet: updatedIsBet, lastWin: winTotal })

            if (maxPayCheck) {
                this.notifyToggle('maxPay', 'show')
                setTimeout(() => this.notifyToggle('maxPay', 'close'), 5000)
            }
        }

        if (result[0]?.result === "win" || result[1]?.result === 'win') {
            sound.play('winsmall', 0.5)
        }
    }

    onTransaction = (data) => {
        if (!data.id) return

        const { transactions } = this.state

        this.setState({ transactions: [...transactions, data] })

        /* Операция уходит в очередь и ждёт, пока освободится место */
        this._operationQueue.push(data)
        this.showNextOperation()
    }

    /* Показ следующей операции: пока предыдущая на экране, очередь ждёт */
    showNextOperation = () => {
        if (this._operationTiming || this._operationQueue.length === 0) return

        const operation = this._operationQueue.shift()

        this.setState({ operations: [operation] })

        this._operationTiming = setTimeout(() => {
            this._operationTiming = null
            this.setState({ operations: [] }, () => this.showNextOperation())
        }, OPERATION_TIME)
    }

    /* Сброс очереди — при разрыве связи и закрытии игры */
    clearOperations = () => {
        clearTimeout(this._operationTiming)
        this._operationTiming = null
        this._operationQueue = []
        this.setState({ operations: [] })
    }

    onEditTransaction = (data) => {
        const { transactions } = this.state
        const updatedList = [...transactions]
        const index = updatedList.findIndex(e => e.number === data.number)

        if (index > -1) {
            updatedList[index] = { ...updatedList[index], status: data.status }
            this.setState({ transactions: updatedList })
        }
    }

    onPause = () => {
        this.setState({ isPaused: true })
        this.notifyToggle('pause', 'show')
    }

    onContinue = () => {
        this.setState({ isPaused: false })
        this.notifyToggle('pause', 'close')
    }

    onForceEnd = () => {
        this.forceEndClear()
        this.setState({ isPaused: false })
        this.notifyToggle('pause', 'close')

        const t = setTimeout(() => {
            this.notifyToggle("forceEnd", "show")
            const close = setTimeout(() => {
                this.notifyToggle("forceEnd", "close")
                clearTimeout(close)
            }, 4000)
            clearTimeout(t)
        }, 2000)
    }

    onTransactionError = () => {
        this.notifyToggle('startError', 'show')
        setTimeout(() => window.location.reload(), 4500)
    }

    onInactionReset = ({ second, quick }) => {
        if (quick) {
            this._timing?.reset(second)
            return
        }

        const t = setTimeout(() => {
            if ((second - 2) <= 0) {
                this.setState({ closed: true })
                this.socket.disconnect()
                this.clear()
            } else {
                this._timing?.reset(second - 2)
            }
            clearTimeout(t)
        }, 2020)
    }

    onInactionDisconnect = () => {
        this.setState({ closed: true })
        this.socket.disconnect()
        this.clear()
    }

    /* Стол на удержании (сильная комбинация) — прячем таймер решения и userTime
       (в шапке GameControl); снова покажется при свежем inactionReset (возобновление) */
    onInactionHold = () => {
        this._timing?.hide()
        this.setState({ userTime: null })
    }

    onMessage = (data) => {
        this._floatingMessages?.sendMessage(data)
        this._background?.current?.addMessage(data)
    }

    onAdminSupportAnswer = (data) => {
        this._floatingMessages?.sendMessage(data)
        this._background?.current?.addSupportMessage(data)
    }


    // ─────────────────────────────────────────────────────────────
    // Image cache
    // ─────────────────────────────────────────────────────────────

    cacheImages = async () => {
        const promises = images.data.map(uri => new Promise((resolve, reject) => {
            const img = new Image()
            img.src = uri
            img.onload = resolve
            img.onerror = reject
        }))

        await Promise.all(promises)
        this.setState({ cached: true })
    }


    // ─────────────────────────────────────────────────────────────
    // Connection
    // ─────────────────────────────────────────────────────────────

    connect = () => {
        this.socket.emit("afterConnect")
    }

    setDealerStatus = (data) => {
        this.notifyToggle('dealer', data ? 'close' : 'show')
    }


    // ─────────────────────────────────────────────────────────────
    // Card helpers
    // ─────────────────────────────────────────────────────────────

    arePlayerCardsEqual = (prevCards, newCards) => {
        if (!Array.isArray(prevCards) || !Array.isArray(newCards)) return false

        const prevTotal = prevCards.reduce((s, b) => s + (b?.length || 0), 0)
        const newTotal = newCards.reduce((s, b) => s + (b?.length || 0), 0)

        if (newTotal < prevTotal || prevCards.length !== newCards.length) return false

        for (let box = 0; box < newCards.length; box++) {
            const prev = prevCards[box] || []
            const next = newCards[box] || []

            if (prev.length !== next.length) return false

            for (let i = 0; i < next.length; i++) {
                const a = prev[i], b = next[i]
                if (!a || !b || a.id !== b.id || a.uid !== b.uid) return false
            }
        }

        return true
    }

    /** Counts the number of truthy values in an array */
    countTruthy = (array) => array.filter(Boolean).length


    // ─────────────────────────────────────────────────────────────
    // Game actions
    // ─────────────────────────────────────────────────────────────

    /* Start a new game round */
    start = debounce(() => {
        const { ante, bonus, max, min, minBonus, currency, withJackpot } = this.state

        /* ANTE сортируется по убыванию, BONUS едет вместе со своим боксом */
        const sortedStake = ante
            .map((value, index) => ({
                ante: parseInt(value) || 0,
                bonus: withJackpot ? (parseInt(bonus[index]) || 0) : 0,
            }))
            .sort((a, b) => b.ante - a.ante)

        const sortedAnte = sortedStake.map(item => item.ante)
        const sortedBonus = sortedStake.map(item => item.bonus)

        const maxAnte = parseFloat(sortedAnte[0])

        const showError = (html) => {
            Swal.fire({
                html,
                backdrop: false, position: 'top',
                showConfirmButton: false, timer: 1500,
                background: '#f44336', customClass: 'swal',
                heightAuto: false, target: document.getElementById("background")
            })
            sound.play('blocked')
        }

        if (maxAnte > max) {
            showError(`<p class="pincode-error">Максимальная ставка ${utils.convertor(max, currency)}</p>`)
            return
        }

        if (maxAnte < min) {
            showError(`<p class="pincode-error">Минимальная ставка ${utils.convertor(min, currency)}</p>`)
            return
        }

        /* BONUS: ставка ниже минимума по бонусу не принимается */
        if (parseInt(minBonus) > 0 && sortedBonus.some(value => value > 0 && value < parseInt(minBonus))) {
            showError(`<p class="pincode-error">Минимальная ставка на бонус ${utils.convertor(minBonus, currency)}</p>`)
            return
        }

        let boxes = 0
        let totalBet = 0
        sortedAnte.forEach((a, index) => { if (a > 0) { totalBet += a + sortedBonus[index]; boxes++ } })

        this.socket.emit("start", { ante: sortedAnte, bonus: sortedBonus, boxes, totalBet })
        this.setState({
            total: totalBet,
            ante: sortedAnte,
            bonus: sortedBonus,
            last: sortedAnte,
            lastBonus: sortedBonus,
            shadow: false,
            activeBoxes: boxes,
            lastWin: 0,
        })
        this.socket.emit("shadow", "no")
        sound.play("placeholder")
    }, 1000, { leading: true, trailing: false })

    setAnte = (data) => {

        if (data === 'all') {
            this.setState({ ante: [0, 0], bonus: [0, 0] })
            return
        }

        const { value, index, cancel, refresh, lastData } = data

        let newAnte = [...this.state.ante]

        if (!refresh) {
            newAnte[index] = value > 0 ? value : 0

            const sorted = [...newAnte].sort((a, b) => parseInt(a) - parseInt(b))
            const maxVal = sorted[sorted.length - 1]

            newAnte.forEach((item, i) => {
                if (parseInt(item) > 0) {
                    newAnte[i] = cancel ? value : maxVal
                }
            })
        } else {
            newAnte = lastData
        }

        /* BONUS снимается с бокса, на котором не осталось ANTE */
        const newBonus = [...this.state.bonus]
        newBonus.forEach((item, i) => {
            if (!(parseInt(newAnte[i]) > 0)) newBonus[i] = 0
        })

        this.setState({ ante: newAnte, bonus: newBonus })
    }


    setBonus = (data) => {

        if (data === 'all') {
            this.setState({ bonus: [0, 0] })
            return
        }

        const { value, index, refresh, lastData } = data

        let newBonus = [...this.state.bonus]

        if (!refresh) {
            newBonus[index] = value > 0 ? value : 0
        } else {
            newBonus = lastData
        }

        this.setState({ bonus: newBonus })
    }

    /**
     * Sets the action for a box (bet / pass / sixth / swap / exchange).
     * When all boxes have actions, submits them to the server.
     */
    setAction = (number, action, needToUpdateTotal = true) => {
        const { ante, actions, used, activeBoxes, exchangeCards, isBet, showInsurance, freezedBoxes, total, game } = this.state

        const updatedActions = [...actions]

        /* Prevent swapping when only 1 card selected */
        if (action === 'swap' && exchangeCards[number]?.length === 1) {
            if (actions[number] === 'swap') updatedActions[number] = null
            this.notifyToggle('swap', 'show')
            setTimeout(() => this.notifyToggle('swap', 'close'), 5000)
            sound.play('blocked')
            return
        }

        /* Clear exchange card selection when switching to a non-swap action */
        if (action !== 'swap' && action !== 0 && !used[number]) {
            const updatedCards = [...exchangeCards]
            updatedCards[number] = []
            this.setState({ exchangeCards: updatedCards })
        }

        /* Bet: update isBet and running total */
        if (action === 'bet') {
            const updatedIsBet = [...isBet]
            updatedIsBet[number] = 'bet'
            this.setState({ isBet: updatedIsBet })
            if (needToUpdateTotal) this.setState({ total: total + ante[0] * 2 })
            sound.play('sound')
        } else {
            if (actions[number] === 'bet' && needToUpdateTotal) {
                this.setState({ total: total - ante[0] * 2 })
            }
            const updatedIsBet = [...isBet]
            updatedIsBet[number] = 'no_bet'
            this.setState({ isBet: updatedIsBet })
        }

        /* Pass: hide insurance panel */
        if (action === 'pass') {
            const updatedShowIns = [...showInsurance]
            updatedShowIns[number] = 0
            this.setState({ showInsurance: updatedShowIns })
        }

        updatedActions[number] = action
        this.setState({ actions: updatedActions })

        /* Count how many boxes have acted */
        const totalActions = updatedActions.filter(Boolean).length
        const finishedActions = updatedActions.filter(a => a === 'pass' || a === 'bet').length
        const passCount = updatedActions.filter(a => a === 'pass').length
        const betCount = updatedActions.filter(a => a === 'bet').length

        /* Swap / Sixth: emit immediately per-box — don't wait for all boxes.
         * React 18 batching causes stale reads when both boxes press swap in the
         * same event loop tick, making totalActions never reach activeBoxes. */
        if (action === 'swap' || action === 'sixth') {
            const { playerGame, isOpen } = this.state
            const newGame = [...game]
            const newPlayerGame = [...playerGame]
            const newIsOpen = [...isOpen]
            const newUsed = [...used]

            newPlayerGame[number] = null
            newGame[number] = action === 'swap' ? 'exchange' : 'sixth'
            newIsOpen[number] = 1
            newUsed[number] = true

            if (action === 'swap') {
                this.socket.emit("exchange", { cards: exchangeCards, box: number })
            } else {
                this.socket.emit("sixth", { status: "ok", box: number })
            }
            sound.play('selectchip')

            /* Freeze any other box that already has a final (bet/pass) action so
             * the backend records it now — without this the BET is lost when
             * onSixth/onExchangeCards resets actions[index] = 0 */
            const newFreezed = [...freezedBoxes]
            updatedActions.forEach((a, i) => {
                if (i !== number && (a === 'bet' || a === 'pass') && !freezedBoxes[i]) {
                    this.socket.emit("freezed", { index: i, action: a })
                    newFreezed[i] = a
                    newGame[i] = a
                }
            })

            this.setState({
                game: newGame,
                playerGame: newPlayerGame,
                isOpen: newIsOpen,
                used: newUsed,
                freezedBoxes: newFreezed,
                showInsurance: [0, 0],
            })

            setTimeout(() => {
                const closed = [...this.state.isOpen]
                closed[number] = 0
                this.setState({ isOpen: closed })
            }, 3000)

            setTimeout(() => this.updateTotal(updatedActions[0], updatedActions[1], number), 500)
            return
        }

        if (totalActions !== activeBoxes || !needToUpdateTotal) return

        /* All bet / pass → submit immediately */
        const allFinal = updatedActions.every(a => a === 'bet' || a === 'pass' || a === 0)
        if (allFinal) {
            this.allBet(updatedActions[0], updatedActions[1])

            const updatedFreezed = [...freezedBoxes]
            updatedActions.forEach((item, i) => {
                if (item === 'bet' || item === 'pass') {
                    this.socket.emit("freezed", { index: i, action: item })
                    updatedFreezed[i] = item
                }
            })

            if (passCount && !betCount) sound.play("autopass")
            this.setState({ freezedBoxes: updatedFreezed })
            return
        }

        /* Mixed actions (swap / sixth + bet/pass)
         * All mutations are accumulated into single arrays first, then applied
         * in ONE setState call to avoid stale-state overwrites between iterations.
         */
        const { playerGame, isOpen, used: currentUsed } = this.state
        const newGame = [...game]
        const newPlayerGame = [...playerGame]
        const newIsOpen = [...isOpen]
        const newUsed = [...currentUsed]
        const newFreezed = [...freezedBoxes]
        const openCloseIdxs = []

        updatedActions.forEach((item, i) => {
            switch (item) {
                case 'swap':
                    if (!currentUsed[i]) {
                        newPlayerGame[i] = null
                        newGame[i] = 'exchange'
                        newIsOpen[i] = 1
                        newUsed[i] = true
                        openCloseIdxs.push(i)
                        this.socket.emit("exchange", { cards: exchangeCards, box: i })
                        sound.play('selectchip')
                    }
                    break

                case 'sixth':
                    if (!currentUsed[i]) {
                        newPlayerGame[i] = null
                        newGame[i] = 'sixth'
                        newIsOpen[i] = 1
                        newUsed[i] = true
                        openCloseIdxs.push(i)
                        this.socket.emit("sixth", { status: "ok", box: i })
                        sound.play('selectchip')
                    }
                    break

                case 'bet':
                    if (finishedActions !== totalActions) {
                        this.socket.emit("freezed", { index: i, action: 'bet' })
                        newFreezed[i] = 'bet'
                        newGame[i] = 'bet'
                    }
                    break

                case 'pass':
                    if (finishedActions !== totalActions) {
                        this.socket.emit("freezed", { index: i, action: 'pass' })
                        newFreezed[i] = 'pass'
                        newGame[i] = 'pass'
                    }
                    break

                default:
                    break
            }
        })

        this.setState({
            game: newGame,
            playerGame: newPlayerGame,
            isOpen: newIsOpen,
            used: newUsed,
            freezedBoxes: newFreezed,
            showInsurance: [0, 0],
        })

        if (openCloseIdxs.length > 0) {
            setTimeout(() => {
                const closed = [...this.state.isOpen]
                openCloseIdxs.forEach(i => { closed[i] = 0 })
                this.setState({ isOpen: closed })
            }, 3000)
        }

        if (passCount && !betCount) sound.play("autopass")
        setTimeout(() => this.updateTotal(updatedActions[0], updatedActions[1], number), 500)
    }

    /* Update displayed total when sixth or swap costs are added */
    updateTotal = (box1, box2, number = 0) => {
        const { ante, total } = this.state
        let sum = total
        if ((box1 === 'swap' || box1 === 'sixth') && number === 0) sum += ante[0]
        if ((box2 === 'swap' || box2 === 'sixth') && number === 1) sum += ante[1]
        this.setState({ total: sum })
    }

    allBet = (box1, box2) => {
        const game = [...this.state.game]
        game[0] = box1
        game[1] = box2
        this.setState({ game, isBet: [box1, box2], showInsurance: [0, 0] })
        this.socket.emit("allBet", { actions: [box1, box2] })
    }

    /* Bet button on player card area */
    bottomBet = (index) => {
        const { playerGame, sixthGame, dealt, game, result, isBet } = this.state
        const canBet = (playerGame[index] || sixthGame[index]) && dealt && game[index] === 'start' && !result[index] && isBet[index] !== "bet"
        if (canBet) {
            this.setAction(index, 'bet')
        } else {
            sound.play('blocked')
        }
    }

    sixth = (number) => {
        sound.play('selectchip')

        const { game, playerGame, isOpen, used } = this.state

        const updatedGame = [...game]; updatedGame[number] = 'sixth'
        const updatedPlayerGame = [...playerGame]; updatedPlayerGame[number] = null
        const updatedIsOpen = [...isOpen]; updatedIsOpen[number] = 1
        const updatedUsed = [...used]; updatedUsed[number] = true

        this.socket.emit("sixth", { status: "ok", box: number })
        this.setState({ used: updatedUsed, isOpen: updatedIsOpen, playerGame: updatedPlayerGame, showInsurance: [0, 0], game: updatedGame })

        setTimeout(() => {
            const closed = [...this.state.isOpen]
            closed[number] = 0
            this.setState({ isOpen: closed })
        }, 3000)
    }

    swap = (number) => {
        const { exchangeCards, game, playerGame, isOpen, used } = this.state
        const boxCards = exchangeCards[number] || []

        if (boxCards.length === 1) {
            this.notifyToggle('swap', "show")
            setTimeout(() => this.notifyToggle('swap', 'close'), 5000)
            sound.play('blocked')
            return
        }

        sound.play('selectchip')

        const updatedPlayerGame = [...playerGame]; updatedPlayerGame[number] = null
        const updatedGame = [...game]; updatedGame[number] = 'exchange'
        const updatedIsOpen = [...isOpen]; updatedIsOpen[number] = 1
        const updatedUsed = [...used]; updatedUsed[number] = true

        this.setState({ used: updatedUsed, isOpen: updatedIsOpen, playerGame: updatedPlayerGame, showInsurance: [0, 0], game: updatedGame })
        this.socket.emit("exchange", { cards: exchangeCards, box: number })

        setTimeout(() => {
            const closed = [...this.state.isOpen]
            closed[number] = 0
            this.setState({ isOpen: closed })
        }, 3000)
    }

    setExchangeCards = (data, index) => {
        const { cards, card_is_added } = data
        if (!(cards[index].length <= 1 && !card_is_added)) {
            this.notifyToggle('swap', 'close')
        }
        this.setAction(index, 0)
        this.setState({ exchangeCards: cards })
        sound.play("clickuibut")
    }

    makePurchase = (value, index) => {
        const { isOpen, game, isPurchase, purchaseResult, ante, total } = this.state

        const updatedPurchaseResult = [...purchaseResult]
        const updatedIsPurchase = [...isPurchase]

        updatedPurchaseResult[index] = value
        updatedIsPurchase[index] = 0

        this.setState({ isPurchase: updatedIsPurchase, purchaseResult: updatedPurchaseResult })

        if (value === 'yes') {
            this.setState({ total: total + ante[0] })
        }

        if (this.countTruthy(updatedIsPurchase) === 0) {
            this.socket.emit("purchase", { purchaseResult: updatedPurchaseResult })

            const updatedIsOpen = [...isOpen]
            const updatedGame = [...game]

            updatedPurchaseResult.forEach((item, i) => {
                if (item === 'yes') {
                    updatedIsOpen[i] = 1
                    updatedGame[i] = 'purchase'
                }
            })

            this.setState({ isOpen: updatedIsOpen, shadow: false, game: updatedGame })
            this.socket.emit("shadow", "no")
            sound.play('selectchip')

            setTimeout(() => {
                const closed = [...this.state.isOpen]
                closed[index] = 0
                this.setState({ isOpen: closed })
            }, 3000)
        }
    }

    makeInsurance = (value, box) => {
        const { insurance, showInsurance, total, actions, balance } = this.state

        if (!balance || parseInt(balance) === 0 || parseInt(balance) <= parseInt(value)) {
            Swal.fire({ title: 'Не хватает средств на балансе', text: 'Чтобы страховаться, пополните свой баланс', timer: 1500, showConfirmButton: false, target: document.getElementById("background") })
            sound.play('blocked')
            return
        }

        if (actions[box] === 'pass') {
            const updatedActions = [...actions]
            updatedActions[box] = 0
            this.setState({ actions: updatedActions })
        }

        sound.play('selectchip')

        const updatedShowIns = [...showInsurance]; updatedShowIns[box] = 0
        const updatedInsurance = [...insurance]; updatedInsurance[box] = value

        this.setState({ insurance: updatedInsurance, showInsurance: updatedShowIns, total: total + parseInt(value) })
        this.socket.emit("insurance", { insurance: value, box })
    }

    showBoxInsurance = (index, action) => {
        const updatedShowIns = [...this.state.showInsurance]
        updatedShowIns[index] = action === 'show' ? 1 : 0
        this.setState({ showInsurance: updatedShowIns })
    }


    // ─────────────────────────────────────────────────────────────
    // UI helpers
    // ─────────────────────────────────────────────────────────────

    checkInternetSpeed = (speed) => {
        this.notifyToggle('internet', parseInt(speed) < 5 ? 'show' : 'close')
    }

    setHeight = (data) => {
        this.socket.emit("heightBack", data)
    }

    setUserTime = (data) => {
        if (!data) {
            this.setState({ userTime: null })
            return
        }
        const m = Math.floor(data / 60)
        const s = data % 60
        this.setState({ userTime: `${m}:${String(s).padStart(2, '0')}` })
    }

    toggleBalanceError = () => {
        if (!this._balanceErrorTiming) this.notifyToggle('balanceError', 'show')
        clearTimeout(this._balanceErrorTiming)
        this._balanceErrorTiming = setTimeout(() => {
            this.notifyToggle('balanceError', 'close')
            this._balanceErrorTiming = null
        }, 2000)
        sound.play('blocked')
    }

    toggleMaxBetError = () => {
        if (!this._maxBetErrorTiming) this.notifyToggle('maxBetError', 'show')
        clearTimeout(this._maxBetErrorTiming)
        this._maxBetErrorTiming = setTimeout(() => {
            this.notifyToggle('maxBetError', 'close')
            this._maxBetErrorTiming = null
        }, 2000)
        sound.play('blocked')
    }

    /* BONUS: лимит бонуса приходит из токена, poker-ui о нём не знает — показываем свой алерт */
    toggleMaxBonusError = () => {
        const { maxBonus, currency } = this.state

        Swal.fire({
            html: `<p class="pincode-error">Максимальная ставка на бонус ${utils.convertor(maxBonus, currency)}</p>`,
            backdrop: false, position: 'top',
            showConfirmButton: false, timer: 1500,
            background: '#f44336', customClass: 'swal',
            heightAuto: false, target: document.getElementById("background")
        })

        sound.play('blocked')
    }

    notifyToggle = (type, action, data = null) => {
        const notifyData = { type, action, data }
        if (this._notify) {
            this.notifyAction(notifyData)
        } else {
            setTimeout(() => {
                if (this._notify) this.notifyAction(notifyData)
            }, 2000)
        }
    }

    notifyAction = ({ type, action, data = null }) => {
        if (action === "show") {
            this._notify.show(type)
        } else if (action === 'close') {
            this._notify.close(type)
        } else if (action === 'refund' && data?.total) {
            const title = data.type === 'refund' ? 'Возврат средств' : "Пополнение суммы"
            this._notify.refund({ title, total: data.total, uid: uuidv4() })
        }
    }

    /* Insurance button for a box */
    renderInsuranceButton = (index) => {
        const { playerGame, sixthGame, insurance, freezedBoxes } = this.state

        const hasHighHand = (
            (playerGame[index] && parseInt(playerGame[index].level) >= 4) ||
            (Array.isArray(sixthGame[index]) && sixthGame[index].length > 0 && sixthGame[index][0].level >= 4)
        )

        if (hasHighHand && parseInt(insurance[index]) === 0 && !freezedBoxes[index]) {
            return <Insurance onClick={() => this.showBoxInsurance(index, 'show')} />
        }
    }


    // ─────────────────────────────────────────────────────────────
    // Box render helpers
    // ─────────────────────────────────────────────────────────────

    renderBoxButtons = (index) => {
        const { result, actions, dealt, used, game, playerGame, sixthGame, exchangeCards, freezedBoxes, insurance, showInsurance, isPurchase, purchaseResult } = this.state

        const position = index === 1 ? 'left' : 'right'
        const buttonStyle = (showInsurance[index] || isPurchase[index] || result[index]) ? 'hidden' : ''
        const swapCards = exchangeCards[index]
        const boxAction = actions[index]
        const boxInsurance = insurance?.[index]
        const isBet = freezedBoxes[index] === 'bet'
        const isPass = freezedBoxes[index] === 'pass'

        const showSwapButton = !used[index] && swapCards?.length > 0 && !isBet && !isPass
        const showSixthButton = !used[index] && (!swapCards || swapCards.length === 0) && !isBet && !isPass

        const show = (
            (!this.countTruthy(result) && playerGame[index] && !purchaseResult[index]) || sixthGame[index]
        ) && dealt && ['start', 'bet', 'pass'].includes(game[index]) && !result[index] && !isPurchase[index] && !purchaseResult[index]

        return (
            <div className={`buttons ${position} ${buttonStyle}`}>
                {show && (
                    <div className="buttons-row" style={{ gap: !used[index] ? 0 : 5 }}>
                        {this.renderInsuranceButton(index)}
                        {showSwapButton && <Swap selected={boxAction === 'swap'} onClick={() => this.setAction(index, 'swap')} />}
                        {showSixthButton && <Buy selected={boxAction === 'sixth'} onClick={() => this.setAction(index, 'sixth')} />}
                        {!isPass && <Play selected={boxAction === 'bet'} onClick={() => this.setAction(index, 'bet')} />}
                        {!(isBet || boxInsurance) && <Pass selected={boxAction === 'pass'} onClick={() => this.setAction(index, 'pass')} />}
                    </div>
                )}
            </div>
        )
    }

    renderBoxInsurance = (index) => {
        const { balance, showInsurance, result, ante, dealt, currency, playerGame, sixthGame, chips, maxPay } = this.state

        const show = showInsurance[index] && !result[index] && ante[index] && dealt
        if (!show) return null

        const position = index ? 'left' : 'right'
        return (
            <Status
                status="insurance"
                currency={currency}
                position={position}
                box={index}
                chips={chips}
                balance={balance}
                playerGame={playerGame[index] || 0}
                sixthGame={sixthGame[index] || []}
                ante={ante[index] || 0}
                maxPay={maxPay}
                makeInsurance={value => this.makeInsurance(value, index)}
                close={() => this.showBoxInsurance(index, "close")}
            />
        )
    }

    renderBoxPurchase = (index) => {
        const { ante, result, showInsurance, dealt, isBet, freezedBoxes, currency, actions, game, isPurchase } = this.state

        const show = isPurchase[index] && (
            (!result[index] && !showInsurance[index] && ante[index] && dealt && !isBet[index]) ||
            (dealt && freezedBoxes[index])
        )

        if (!show) return null

        const position = index ? 'left' : 'right'
        return (
            <Status
                currency={currency}
                box={index}
                result={result}
                freezedBoxes={freezedBoxes}
                actions={actions}
                status={game[index]}
                position={position}
                isPurchase={isPurchase[index]}
                makePurchase={value => this.makePurchase(value, index)}
            />
        )
    }

    renderBoxResult = (index) => {
        const { result, currency } = this.state
        if (!result?.[index]) return null

        return (
            <Status
                position={index ? "left" : "right"}
                vip={true}
                status="result"
                data={result[index]}
                currency={currency}
                isPurchase={false}
            />
        )
    }

    renderGameBox = () => {
        const { status, balance, ante, bonus, last, lastBonus, isBet, actions, dealer, dealerGame, player, playerGame, dealt, isOpen, result, bonusResult, currency, used, exchangeCards, sixthGame, isPurchase, removedCard, insurance, isTableEmpty, insuranceStatus, freezedBoxes, activeBoxes, activeChip, chips, max, maxBonus, withJackpot } = this.state

        if (isTableEmpty) {
            return <Busy onConnect={() => this.connect()} />
        }

        if (status === INTERVAL) {
            return <div />
        }

        if (status === GAME) {
            const style = activeBoxes === 1 ? 'one-box' : ''

            return (
                <div className={`play ${style}`}>
                    {BOXES.map((_, index) => {
                        const position = index === 0 ? 'right' : 'left'
                        const freezed = freezedBoxes[index] === 'pass' ? 'freezed' : ''
                        const boxStyle = ante[index] ? '' : 'hidden'
                        const showFreezeBox = freezedBoxes[index] && !isPurchase[index]

                        return (
                            <div className={`card-box ${position}`} key={index}>

                                {index === 0
                                    ? <DealerCards cards={dealer} game={dealerGame} dealt={dealt} removedCard={removedCard} />
                                    : <div className="dealer-cards-box left" />
                                }

                                <div className={`card-box-bottom ${position} ${boxStyle}`}>
                                    <p className="boxNumber">Бокс {index + 1}</p>

                                    <VipMobileRate
                                        actions={actions}
                                        currency={currency}
                                        position={position}
                                        status={status}
                                        box={index}
                                        ante={ante}
                                        bonus={bonus}
                                        withJackpot={withJackpot}
                                        result={result}
                                        bonusResult={bonusResult}
                                        activeBoxes={activeBoxes}
                                        freezedBoxes={freezedBoxes}
                                        isBottom={true}
                                        isBet={isBet}
                                        isOpen={isOpen}
                                        insurance={insurance}
                                        insuranceStatus={insuranceStatus}
                                        add={() => { }}
                                        bet={box => this.bottomBet(box)}
                                        chips={chips}
                                    />

                                    <div className={`player-game ${freezed}`}>
                                        {showFreezeBox && <div className="freeze_box" />}

                                        {player[index] && Array.isArray(player[index]) && (
                                            <PlayerCards
                                                position={position}
                                                box={index}
                                                cards={player[index]}
                                                game={playerGame[index] || null}
                                                dealt={dealt}
                                                sixthGame={sixthGame[index]}
                                                exchangeCards={exchangeCards}
                                                setExchangeCards={data => this.setExchangeCards(data, index)}
                                                used={used[index]}
                                            />
                                        )}

                                        {this.renderBoxButtons(index)}
                                        {this.renderBoxInsurance(index)}
                                        {this.renderBoxPurchase(index)}
                                        {this.renderBoxResult(index)}
                                    </div>
                                </div>
                            </div>
                        )
                    })}

                    <VipRates
                        actions={actions}
                        currency={currency}
                        gameScreen={true}
                        status={status}
                        ante={ante}
                        bonus={bonus}
                        withJackpot={withJackpot}
                        playerGame={playerGame}
                        sixthGame={sixthGame}
                        result={result}
                        bonusResult={bonusResult}
                        dealt={dealt}
                        boxes={BOXES}
                        isBottom={true}
                        isBet={isBet}
                        isOpen={isOpen}
                        insurance={insurance}
                        insuranceStatus={insuranceStatus}
                        add={() => { }}
                        bet={box => this.bottomBet(box)}
                        chips={chips}
                    />
                </div>
            )
        }

        if (status === CHOICE) {
            return (
                <Bet
                    activeBoxes={activeBoxes}
                    ante={ante}
                    bonus={bonus}
                    last={last}
                    lastBonus={lastBonus}
                    max={max}
                    maxBonus={maxBonus}
                    withJackpot={withJackpot}
                    setAnte={data => this.setAnte(data)}
                    setBonus={data => this.setBonus(data)}
                    balance={balance}
                    boxes={BOXES}
                    result={result}
                    start={() => this.start()}
                    currency={currency}
                    toggleBalanceError={() => this.toggleBalanceError()}
                    toggleMaxBetError={() => this.toggleMaxBetError()}
                    toggleMaxBonusError={() => this.toggleMaxBonusError()}
                    activeChip={activeChip}
                    setActiveChip={value => this.setState({ activeChip: value })}
                    chips={chips}
                />
            )
        }

        return <div />
    }


    // ─────────────────────────────────────────────────────────────
    // Render
    // ─────────────────────────────────────────────────────────────

    render = () => {
        const {
            status, cached, dealerInfo, currency, total, balance, lastWin,
            transactions, gameInfo, operations, histories, historyPage, historyHasMore,
            closed, newDevice, max, min, maxPay, isDisconnected, isPaused,
            identifier, backColor, gameImg, operator, userTime, withJackpot, jackpot, jackpotWin, maxBonus, minBonus
        } = this.state

        const gamePayout = <GamePayout currency={currency} max={max} min={min} maxPay={maxPay} withJackpot={withJackpot} maxBonus={maxBonus} minBonus={minBonus} />

        if (status === ERROR || newDevice || closed || isDisconnected) {
            return <Error newDevice={newDevice} closed={closed} isDisconnected={isDisconnected} />
        }

        if (status === LOADING || !cached) {
            return <Preloader url={gameImg} />
        }

        return (
            <Background
                token={token}
                historyComponent={History}
                ref={this._background}
                gameType="vmp"
                gamePlace={env.gamePlace}
                currency={currency}
                maxPay={maxPay}
                status={status}
                dealer={dealerInfo}
                sendMessage={message => this.sendMessage(message)}
                sendSupportMessage={message => this.sendSupportMessage(message)}
                info={gameInfo}
                transactions={transactions}
                histories={histories}
                loadMore={() => this.loadHistory(historyPage + 1)}
                historyHasMore={historyHasMore}
                gamePayout={gamePayout}
                identifier={identifier}
                operator={operator}
                rules={list}
                videoBackImg={gameImg}
                textileColor={backColor}
                userTime={userTime}
            >
                <Timing ref={ref => this._timing = ref} status={status} isPaused={isPaused} setUserTime={data => this.setUserTime(data)} />
                <GameControl title={`${env.name} ${env.number}`} maxPay={maxPay} max={max} min={min} gamePayout={gamePayout} currency={currency} info={gameInfo} data={dealerInfo} operator={operator} userTime={userTime} onQuitGame={() => { }} />
                <GameInfo currency={currency} info={gameInfo} operations={operations} />
                <Balance balance={balance} total={total} operator={operator} lastWin={lastWin} currency={currency} />
                <FloatingMessages ref={ref => this._floatingMessages = ref} />

                {withJackpot && <Jackpot jackpot={jackpot} />}

                {jackpotWin && <JackpotWin amount={jackpotWin.total} usd={jackpotWin.usd} demo={jackpotWin.demo} currency={currency} onClose={() => this.setState({ jackpotWin: null })} />}

                {this.renderGameBox()}

                <div className="bottom-shadow" />
                <Notification nextGame={false} ref={ref => this._notify = ref} currency={currency} max={max} maxPay={maxPay} />
                <Internet setInternetSpeed={data => this.checkInternetSpeed(data)} url={imgUrl} />
            </Background>
        )
    }
}

export default App